<template>
    <transition name="modal">
        <div class="modal-mask" v-show="show">
            <div class="modal-container">
                <div class="modal-header">
                    <h3>Agendamentos ainda não realizados deste paciente</h3>
                </div>
                <div class="modal-body">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>Situação</th>
                                <th>Unidade realizadora</th>
                                <th>Data da realização</th>
                                <th>Prof. Realizador</th>
                                <th>Procedimento</th>
                                <th>Solicitado em</th>
                                <th>Unidade solicitante</th>
                                <th>Prof. Solicitante</th>
                                <th>Prof. Marcador</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="even" role="row" v-for="(item, index) in $props.naoRealizados" :key="index">
                                <td>
                                    <strong :class="item.solicitacao.situacao | situacaoSolicitacaoColor">
                                        {{ item.solicitacao.situacao | situacaoSolicitacao }}
                                    </strong>
                                </td>
                                <td>{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome }}</td>
                                <td>{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento | dataFormatada }} às {{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.hora_inicial : item.contrato_subgrupo_atendimento.hora_inicial }}</td>
                                <td>{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL" }}</td>
                                <td>{{ item.contrato_procedimento.procedimento.nome }}</td>
                                <td>{{ item.solicitacao.created_at | dataFormatada }}</td>
                                <td>{{ item.contrato_procedimento.contrato.unidade.nome }}</td>
                                <td>{{ item.solicitacao.profissional.nome }}</td>
                                <td>{{ item.solicitacao.usuario.name }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button :class="{ 'pull-left': !$props.regulacao, 'pull-right': $props.regulacao }" class="btn btn-default" @click="$emit('close')"><i class="fa fa-close"></i> Fechar</button>
                    <button ref="selecionarProfissional" v-if="!$props.regulacao" @click="$emit('selecionarProfissional')" class="btn btn-primary pull-right"><i class="fa fa-arrow-right"></i> Selecionar profissional</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ["show", "naoRealizados", "regulacao"],
    data: () => ({}),
    mounted() {},
    methods: {},
    watch: {
        "$props.show": function(val) {
            if (val) {
                this.$nextTick(() => this.$refs.selecionarProfissional.focus());
            }
        }
    }
};
</script>

<style scoped>
* {
    box-sizing: border-box;
}

.modal-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
}

.modal-container {
    width: 70%;
    margin: 40px auto 0;
    padding: 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
    margin-top: 0;
    color: #333;
}

.modal-body {
    margin: 10px 0;
}

.text-right {
    text-align: right;
}

.form-label {
    display: block;
    margin-bottom: 1em;
}

.form-label > .form-control {
    margin-top: 0.5em;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
}

/*
											 * The following styles are auto-applied to elements with
											 * transition="modal" when their visibility is toggled
											 * by Vue.js.
											 *
											 * You can easily play with the modal transition by editing
											 * these styles.
											 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.modal {
    display: block !important;
    /* I added this to see the modal, you don't need this */
}

/* Important part */

.modal-dialog {
    overflow-y: initial !important;
}

.modal-body {
    height: 350px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// modalNaoRealizados.vue?2f00f9e8